<highcharts-chart
    *ngIf="isHighcharts"
    [Highcharts]="Highcharts"
    [options]="shadowOptions"
    [(update)]="chartUpdateFlag"
    [oneToOne]="true"
    [style]="{width: width, height: height, display: 'block'}"
></highcharts-chart>
